import type { ShopifyCompletionCommand, ShopifyCompletionDto } from '../models/callback.types'

import { ShopifyCallbackService } from './shopifyCallbackService'

const service = new ShopifyCallbackService()

/** Public atomic completion seam shared by callback routes and signup-MFA. */
export function completeShopifyInstall(
  command: ShopifyCompletionCommand,
): Promise<ShopifyCompletionDto> {
  return service.complete(command)
}
